module.exports = __webpack_public_path__ + "static/media/21ECLAC6.330a2814.jpg";